import { render, staticRenderFns } from "./PublicPost.vue?vue&type=template&id=05be4a95&"
import script from "./PublicPost.vue?vue&type=script&lang=js&"
export * from "./PublicPost.vue?vue&type=script&lang=js&"
import style0 from "./PublicPost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports